module.exports = __webpack_public_path__ + "img/PET_logo_feher.9f746bb2.png";